import { Card, CardContent, CardHeader, CircularProgress } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import { CustomDescrypt } from 'global/func'
import { postDataWithResponse } from 'global/postFunc'
import React, { useEffect, useState } from 'react'
import userStore from 'store/userStore'
import TambahMonev from './TambahMonev'
import ListMonev from './ListMonev'

const Monev = ({ komponenData, allowEdit }) => {
    const { user, addReq } = userStore(state => ({ user: state.user, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const [monevData, setMonevData] = useState([])

    const [updating, setUpdating] = useState(false)
    const [loading, setLoading] = useState(false)

    const reqMonev = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            `/admin-opd/monev/filter`,
            {
                id_komponen: komponenData.id
            },
            decryptedUser,
            (res) => {
                setMonevData(res)
                console.log(res);
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }
        )
    }

    useEffect(() => {
        reqMonev();
        // eslint-disable-next-line react-hooks/exhaustive-deps, no-use-before-define
    }, [updating])

    return (
        <ArgonBox mb={3}>
            <Card>
                <CardHeader
                    title={
                        <ArgonTypography variant='subtitle2' fontWeight="bold">Monitoring Dan Evaluasi</ArgonTypography>
                    }
                    action={
                        allowEdit &&
                        <TambahMonev
                            komponenData={komponenData}
                            updating={updating}
                            setUpdating={setUpdating}
                        />
                    }
                />
                <CardContent>
                    <ArgonBox>
                        {
                            loading ?
                                <ArgonBox align="center" mt={3}>
                                    <CircularProgress />
                                </ArgonBox>
                                :
                                monevData.length > 0 ?
                                    monevData.map((monev, index) => (
                                        <ArgonBox mt={3} key={index}>
                                            <ListMonev
                                                monevData={monev}
                                                ta={komponenData.ta}
                                                setUpdating={setUpdating}
                                                updating={updating}
                                                allowEdit={allowEdit}
                                            />
                                        </ArgonBox>
                                    ))
                                    :
                                    <ArgonBox align="center" mt={3}>
                                        <ArgonTypography variant='caption' >Tidak ada Data</ArgonTypography>
                                    </ArgonBox>
                        }
                    </ArgonBox>
                </CardContent>
            </Card>
        </ArgonBox>
    )
}

export default Monev